import { Controller } from '@hotwired/stimulus'

import { digProperty } from '../../src/mixins/dig'

// Tiles that are not reachable are shown first, followed by the tiles without data
const TILE_ORDER = { false: 0, null: 1, true: 2, unchecked: 2 }

// A device missing from the status has no data, and reachability is only checked while a device is on and has an `is_reachable` flag.
const tileState = (device, isOn, isReachable) => {
  if (device === null) return 'null'
  if (isOn !== true || isReachable === null) return 'unchecked'
  return String(isReachable)
}

// Marks each tile by its state (in `data-reachable`), shows the tiles that need attention first and counts the reachable, unreachable and no data ones.
export default class extends Controller {
  static targets = ['tile', 'summary']
  static classes = ['alert']

  // Without a status, e.g. when the poller cannot reach the status service, no device has any data.
  connect () {
    this.update({ detail: {} })
  }

  update ({ detail }) {
    const totals = { true: 0, false: 0, null: 0 }

    this.tileTargets.forEach(tile => {
      const device = digProperty(tile.dataset.deviceField, detail)
      const isOn = digProperty(tile.dataset.onField, detail)
      const isReachable = digProperty(tile.dataset.reachableField, detail)
      const state = tileState(device, isOn, isReachable)

      if (state in totals) totals[state] += 1
      tile.dataset.reachable = state
      tile.style.order = TILE_ORDER[state]
    })

    this.summaryTargets.forEach(summary => {
      const total = totals[summary.dataset.reachable]

      summary.querySelector('[data-count]').textContent = total

      if (summary.dataset.alert) {
        this.alertClasses.forEach(name => summary.classList.toggle(name, total > 0))
      }
    })
  }
}
